import { useEffect, useState } from "react"
import { useAppDispatch, useAppSelector } from "../../../../lib/redux/hooks"
import { GGNotificationMemberDTO } from "./dataservice/dto"
import { formatterDate, GGCropTypeOptions, GGManipulationOptions, optionsFormatter } from "../../../../utils"
import { GetAllGGNotificationMember, GGNotificationMemberDelete, resetMemberDeleteStatus } from "./slice"
import { TrashIcon } from "../../../../ui/icons/trash"
import Button from "../../../../ui/molecules/button"
import { Alert } from "../../../../ui/organisms/alert"
import { PopupForm } from "../../../../ui/organisms/popupForm"
import { resetCreationStatus } from "../../../gestioneProvvedimenti/measuresOtherOdc/dataService/slice"
import { Option2Popup } from "./popup"

export function GlobalGapOpzione2() {
    const dispatch = useAppDispatch()
    const ggNotificationMemberState = useAppSelector(state => state.ggNotificationMember)
    const ggNotificationState = useAppSelector(state => state.ggNotification)
    const [showSuccess, setShowSuccess] = useState<boolean>(false)
    const [showAddPopup, setShowAddPopup] = useState<boolean>(false)
    const [showAlert, setShowAlert] = useState<boolean>(false)
    const [memberToDelete, setMemberToDelete] = useState<GGNotificationMemberDTO | null>(null)

    useEffect(() => {
        dispatch(GetAllGGNotificationMember({
            itemsPerPage: 0,
            page: 0,
            ggNotificationId: ggNotificationState.ggNotificationIdToUpdate
        }))
    }, [])

    useEffect(() => {
        if(ggNotificationMemberState.memberDeleteStatus === 'successfully') {
            dispatch(resetMemberDeleteStatus())
            dispatch(GetAllGGNotificationMember({
                itemsPerPage: 0,
                page: 0,
                ggNotificationId: ggNotificationState.ggNotificationIdToUpdate
            }))
        }
    }, [ggNotificationMemberState.memberDeleteStatus])

    useEffect(() => {
        if(ggNotificationMemberState.memberCreationStatus === 'successfully') {
            dispatch(resetCreationStatus())
            dispatch(GetAllGGNotificationMember({
                itemsPerPage: 0,
                page: 0,
                ggNotificationId: ggNotificationState.ggNotificationIdToUpdate
            }))
        }
    }, [ggNotificationMemberState.memberCreationStatus])

    useEffect(() => {
        if (showSuccess) {
            setTimeout(() => {
                setShowSuccess(false)
            }, 2000)
        }
    }, [showSuccess])

    return (
        <div>
            {
                (showSuccess) &&

                <div className="gap-[8px] text-left bg-green-300" style={{ margin: '24px', borderRadius: '8px' }}>
                    <span className="text-green-700 fieldsetTitle" style={{ padding: '30px 25px', fontSize: '14px', fontFamily: 'Roboto', fontWeight: '700', display: 'block' }}>
                        Dati salvati correttamente.
                    </span>
                </div>
            }
            <div style={{ padding: '24px' }}>
                <table id="users-table" className="w-[100%]">
                    <thead className="h-[52px] uppercase">
                        <tr>
                            <th style={{ borderTopLeftRadius: '8px' }}></th>
                            <th className="width-[130px]">Data</th>
                            <th className="width-[130px]">GGN</th>
                            <th className="width-[130px]">Ragione Sociale</th>
                            <th className="width-[100px]">Responsabile</th>
                            <th className="width-[130px]">Indirizzo Sede Legale</th>
                            <th className="width-[20%]">Prodotto</th>
                            <th className="width-[130px]">Tipo Coltura</th>
                            <th className="width-[130px]">Periodo Raccolta</th>
                            <th className="width-[130px]">Tipo Manipolazione</th>
                            <th className="width-[130px]">Propretà Parallela</th>
                            <th className="width-[130px]">Attività subappaltata</th>
                            <th className="width-[130px]">COOP</th>
                            <th className="width-[130px]">GRASP</th>
                            <th className="width-[130px]">SPRING</th>
                            <th className="width-[130px]">Paese Destinazione</th>
                            <th className="width-[130px]">Numero/Descrizione SP</th>
                            <th className="width-[130px]">Indirizzo SP</th>
                            <th className="width-[130px]">Latitudine SP</th>
                            <th className="width-[130px]">Longitudine SP</th>
                            <th style={{ borderTopRightRadius: '8px', width: '40px' }}></th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            ggNotificationMemberState.getAllMemberResponse?.data.map((m, index) =>
                                <tr
                                    key={index}
                                    style={{
                                        color: '#4D797F',
                                        background: index % 2 === 0 ? '#F2F7F7' : '#FFFFFF'
                                    }}
                                >
                                    <td></td>
                                    <td>{formatterDate(m.createdAt)}</td>
                                    <td>{m.ggn}</td>
                                    <td>{m.companyName}</td>
                                    <td>{m.supervisor}</td>
                                    <td>{m.registeredOfficeAddress}</td>
                                    <td>{m.product}</td>
                                    <td>{optionsFormatter(m.cropType!, GGCropTypeOptions)}</td>
                                    <td>{m.harvestingPeriod}</td>
                                    <td>{optionsFormatter(m.manipulationType!, GGManipulationOptions)}</td>
                                    <td>{m.parallelProperty? 'Sì' : 'No'}</td>
                                    <td>{m.subcontractedActivity}</td>
                                    <td>{m.coopModule ? 'Sì' : 'No'}</td>
                                    <td>{m.graspModule? 'Sì' : 'No'}</td>
                                    <td>{m.springModule? 'Sì' : 'No'}</td>
                                    <td>{m.destinationCountry}</td>
                                    <td>{m.description}</td>
                                    <td>{m.address}</td>
                                    <td>{m.latitude}</td>
                                    <td>{m.longitude}</td>
                                    <td>
                                        <button onClick={() => {
                                            setMemberToDelete(m)
                                            setShowAlert(true)
                                        }}>
                                            <TrashIcon color="red" size={20} />
                                        </button>
                                    </td>
                                </tr>
                            )}
                    </tbody>
                </table>

                <div className="mt-5" style={{ display: 'flex', justifyContent: 'flex-end', gap: '24px' }}>
                    <Button
                        variant="outline"
                        color="dimgrey"
                        size="md"
                        iconPosition="off"
                        label="Aggiungi"
                        onClick={() => setShowAddPopup(true)}
                    />
                </div>
            </div>
            {
                (showAlert && memberToDelete) && (
                    <Alert title="Conferma operazione" close={() => setShowAlert(false)}>
                        <div style={{ display: "flex", flexDirection: 'column', justifyContent: 'center' }}>
                            <div className="pb-3">
                                <div>
                                    Sei sicuro di voler eliminare il seguente membro?
                                </div>
                                <div className="mt-3 font-bold">
                                    {`${memberToDelete.companyName} - ${memberToDelete.supervisor}`}
                                </div>
                            </div>
                            <div className="mt-6" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                <Button
                                    variant="outline"
                                    color="dimgrey"
                                    iconPosition="off"
                                    label="Annulla"
                                    size="md"
                                    onClick={() => setShowAlert(false)}
                                />
                                <div className="pl-8">
                                    <Button
                                        variant="solid"
                                        color="orange"
                                        iconPosition="off"
                                        label="Elimina"
                                        size="md"
                                        onClick={() => {
                                            dispatch(GGNotificationMemberDelete(memberToDelete.id!))
                                            setShowAlert(false)
                                        }}
                                    />
                                </div>
                            </div>

                        </div>
                    </Alert>
                )
            }
            {
                showAddPopup &&
                <PopupForm title={`Aggiungi membro`} headerGreen close={() => setShowAddPopup(false)}>
                    <Option2Popup close={() => setShowAddPopup(false)}></Option2Popup>
                </PopupForm>
            }
        </div>
    )
}